const state = {
  loginType: 0,
  loginUserForm: ''
};

const mutations = {
  SET_LOGINTYPE: (state, type) => {
    state.loginType = type;
  },
  SET_LOGINUSERFORM: (state, type) => {
    state.loginUserForm = type;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
